// extracted by mini-css-extract-plugin
export default {"root":"SettingsSection_root__1Gh-s","invisible":"SettingsSection_invisible__zYoyH","list":"SettingsSection_list__tO6-l","title":"SettingsSection_title__u7rdb"};